module.exports = __webpack_public_path__ + "static/media/youtube-play.209db244.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/youtube-play.png
 ** module id = 689
 ** module chunks = 0
 **/